/* src/app/views/contract-manual/contract-manual.component.scss */
.title {
  font-weight: 500;
  font-style: normal;
  font-size: clamp(32px, 3.2vw, 48px);
  line-height: 1.08;
  color: #102b4e !important;
  padding: 2%;
  display: block;
  letter-spacing: -0.03em;
}
.loading {
  position: absolute;
  top: 35%;
  left: 50%;
  font-size: 60px;
  font-weight: bold;
}
.container {
  padding: 20px;
  box-sizing: border-box;
}
.container > .grid {
  margin: 0 !important;
}
.container > .grid > [class*=col-] {
  padding-left: 20px;
  padding-right: 20px;
}
.search-filters-wrapper {
  padding: 0 20px !important;
  margin-top: 20px !important;
  width: 100%;
  box-sizing: border-box;
}
::ng-deep .search-filters-wrapper .p-accordion,
::ng-deep .search-filters-wrapper .ui-accordion {
  width: 100%;
  border-radius: 10px;
  overflow: hidden;
}
::ng-deep .search-filters-wrapper .p-accordion-panel,
::ng-deep .search-filters-wrapper .ui-accordion-tab {
  border: none;
  background: transparent;
}
::ng-deep .search-filters-wrapper .p-accordion-header {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 10px 10px 0 0;
  margin-bottom: 0;
}
::ng-deep .search-filters-wrapper .p-accordion-header-link,
::ng-deep .search-filters-wrapper .ui-accordion-header a {
  border-radius: 10px 10px 0 0;
}
::ng-deep .search-filters-wrapper .p-accordion .p-accordion-content,
::ng-deep .search-filters-wrapper .ui-accordion .ui-accordion-content,
::ng-deep .search-filters-wrapper .p-accordion-content,
::ng-deep .search-filters-wrapper .ui-accordion-content {
  padding: 20px !important;
  box-sizing: border-box;
  overflow-x: hidden;
  border-radius: 0 0 10px 10px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-top: none;
}
::ng-deep .search-filters-wrapper .p-accordion-content > *,
::ng-deep .search-filters-wrapper .ui-accordion-content > * {
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}
.filtro {
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 6px;
  display: inline-block;
  color: #102b4e;
}
.filters-grid {
  display: grid !important;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  column-gap: 12px;
  row-gap: 2px;
  align-items: start;
  width: 100%;
  margin: 8px 0 0;
}
.filter-item {
  width: 100% !important;
  max-width: 100% !important;
  padding: 0;
  margin: 0;
  min-width: 0;
}
.filter-item.full-row {
  grid-column: 1/-1;
}
.content-card {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.search-filters-wrapper > .content-card {
  margin-top: 14px;
}
.search-filters-wrapper > .content-card + .content-card {
  margin-top: 0;
}
.validation-table-section {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 28px;
}
.contracts-table-section {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 28px;
}
.validation-actions-row {
  margin-bottom: 50px;
}
.validation-actions-row + .validation-table-section {
  margin-top: 0;
}
.section-actions-row {
  margin-top: 28px;
  margin-bottom: 28px;
}
.contracts-actions-row {
  margin-top: 28px;
  margin-bottom: 28px;
}
.validation-table-section .filtro,
.contracts-table-section .filtro {
  font-size: 18px;
  font-weight: 700;
  line-height: 28px;
  margin-bottom: 16px;
  display: block;
  color: #102b4e;
}
.filter-hint-row .filtro {
  margin-bottom: 0;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
}
.filter-hint-row {
  grid-column: 1/-1;
  margin-top: 2px;
  padding-left: 0;
  margin-bottom: 0;
}
.filter-hint-row .field-hint {
  margin-top: 0;
  margin-bottom: 0;
}
.filter-actions-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
  margin: 40px 0 0;
  padding-top: 14px;
  border-top: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.search-filters-wrapper,
.content-card,
.contracts-table-section,
.contracts-actions-row,
.novo-secondary-actions {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
}
.novo-content-area {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  box-sizing: border-box;
}
.novo-content-area > .filters-grid,
.novo-content-area > .filter-actions-row,
.novo-content-area > .filter-item {
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  margin-left: 0;
  margin-right: 0;
}
.search-filters-wrapper .filters-grid,
.search-filters-wrapper .filter-item,
.search-filters-wrapper .filter-item.full-row,
.search-filters-wrapper .filter-actions-row,
.contracts-table-section,
.contracts-actions-row {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}
::ng-deep .search-filters-wrapper .p-datatable,
::ng-deep .search-filters-wrapper .ui-datatable,
::ng-deep .contracts-table-section .p-datatable,
::ng-deep .contracts-table-section .ui-datatable {
  width: 100% !important;
  max-width: 100% !important;
}
::ng-deep .search-filters-wrapper .p-datatable-wrapper,
::ng-deep .search-filters-wrapper .ui-datatable-tablewrapper,
::ng-deep .contracts-table-section .p-datatable-wrapper,
::ng-deep .contracts-table-section .ui-datatable-tablewrapper {
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  box-sizing: border-box;
}
::ng-deep .search-filters-wrapper .p-datatable table,
::ng-deep .search-filters-wrapper .ui-datatable table,
::ng-deep .contracts-table-section .p-datatable table,
::ng-deep .contracts-table-section .ui-datatable table {
  width: 100%;
  max-width: 100%;
}
::ng-deep #contractsManual .p-datatable-table,
::ng-deep #contractsManual table {
  min-width: 2680px;
  table-layout: auto;
}
::ng-deep #contractsManual .contracts-product-col {
  width: 540px !important;
  min-width: 540px !important;
  max-width: 540px !important;
}
.filters-grid input[pInputText],
.filters-grid textarea[pInputTextarea],
.filters-grid .textarea {
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
}
.filters-grid input[pInputText] {
  height: 48px;
  padding-left: 12px;
}
::ng-deep .filters-grid .ui-dropdown,
::ng-deep .filters-grid .p-dropdown,
::ng-deep .filters-grid .ui-calendar .ui-inputtext,
::ng-deep .filters-grid .p-calendar .p-inputtext {
  width: 100% !important;
  min-height: 48px;
  border-radius: 10px;
}
.filters-grid .textarea {
  height: 120px !important;
  overflow-y: auto !important;
  resize: none;
}
.row-icon-button {
  min-width: 40px !important;
  width: 40px !important;
  height: 40px !important;
  padding: 0 !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  background: #046cea !important;
  border-color: #046cea !important;
  color: #ffffff !important;
  border-radius: 8px !important;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}
.table-row-center {
  text-align: center;
}
.table-empty-message {
  text-align: left !important;
  color: #6d7682;
  font-size: 13px;
  line-height: 20px;
  padding: 14px 10px !important;
}
.row-status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 12px;
}
.row-status-error {
  color: #d13d3d;
  background: #fdeeee;
}
.row-status-success {
  color: #0b8b45;
  background: #e9f8ef;
}
.contract-status-message {
  display: inline-block;
  max-width: 100%;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contract-status-error {
  color: #b02e2e;
  background: #fdeeee;
}
.contract-status-success {
  color: #0b8b45;
  background: #e9f8ef;
}
.row-icon-button .pi {
  margin: 0 !important;
  color: #ffffff !important;
}
.row-icon-button:hover:not(:disabled),
.row-icon-button:focus:not(:disabled),
.row-icon-button:active:not(:disabled) {
  background: #0353a8 !important;
  border-color: #0353a8 !important;
}
:host ::ng-deep #home-content .container .filter-actions-row button .pi,
:host ::ng-deep #home-content .container .filter-actions-row button i,
:host ::ng-deep #home-content .container .filter-actions-row button .action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button .undo-action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button span {
  color: inherit !important;
  opacity: 1 !important;
}
:host ::ng-deep #home-content .container .filter-actions-row button.app-clean-button.undo-action-button,
:host ::ng-deep #home-content .container .filter-actions-row button.app-clean-button.undo-action-button:hover:not(:disabled) {
  color: #046cea !important;
}
:host ::ng-deep #home-content .container .filter-actions-row button.app-clean-button.undo-action-button:disabled,
:host ::ng-deep #home-content .container .filter-actions-row button.app-clean-button.undo-action-button[disabled],
:host ::ng-deep #home-content .container .filter-actions-row button.app-clean-button.undo-action-button.p-disabled,
:host ::ng-deep #home-content .container .filter-actions-row button.app-clean-button.undo-action-button.ui-state-disabled {
  color: #6f6f6f !important;
}
:host ::ng-deep #home-content .container .filter-actions-row button:hover:not(:disabled) .pi,
:host ::ng-deep #home-content .container .filter-actions-row button:hover:not(:disabled) i,
:host ::ng-deep #home-content .container .filter-actions-row button:hover:not(:disabled) .action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button:hover:not(:disabled) .undo-action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button:hover:not(:disabled) span,
:host ::ng-deep #home-content .container .filter-actions-row button:disabled .pi,
:host ::ng-deep #home-content .container .filter-actions-row button:disabled i,
:host ::ng-deep #home-content .container .filter-actions-row button:disabled .action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button:disabled .undo-action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button:disabled span,
:host ::ng-deep #home-content .container .filter-actions-row button[disabled] .pi,
:host ::ng-deep #home-content .container .filter-actions-row button[disabled] i,
:host ::ng-deep #home-content .container .filter-actions-row button[disabled] .action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button[disabled] .undo-action-button-label,
:host ::ng-deep #home-content .container .filter-actions-row button[disabled] span {
  color: inherit !important;
  opacity: 1 !important;
}
:host ::ng-deep #home-content .row-icon-button .pi,
:host ::ng-deep #home-content .row-icon-button i {
  color: #ffffff !important;
}
:host ::ng-deep #home-content button.undo-action-button.row-icon-button,
:host ::ng-deep #home-content .undo-action-button.row-icon-button,
:host ::ng-deep #home-content button.action-button-return.row-icon-button,
:host ::ng-deep #home-content .action-button-return.row-icon-button {
  color: #ffffff !important;
}
:host ::ng-deep #home-content button.undo-action-button.row-icon-button:hover:not(:disabled),
:host ::ng-deep #home-content .undo-action-button.row-icon-button:hover:not(:disabled),
:host ::ng-deep #home-content button.action-button-return.row-icon-button:hover:not(:disabled),
:host ::ng-deep #home-content .action-button-return.row-icon-button:hover:not(:disabled) {
  color: #ffffff !important;
}
.row-icon-button:disabled,
.row-icon-button[disabled],
.row-icon-button.p-disabled,
.row-icon-button.ui-state-disabled {
  background: #e0e0e0 !important;
  border-color: #c4c4c4 !important;
  color: #6f6f6f !important;
}
.row-icon-button:disabled .pi,
.row-icon-button[disabled] .pi,
.row-icon-button.p-disabled .pi,
.row-icon-button.ui-state-disabled .pi {
  color: #6f6f6f !important;
}
:host ::ng-deep #home-content .row-icon-button:disabled .pi,
:host ::ng-deep #home-content .row-icon-button[disabled] .pi,
:host ::ng-deep #home-content .row-icon-button.p-disabled .pi,
:host ::ng-deep #home-content .row-icon-button.ui-state-disabled .pi,
:host ::ng-deep #home-content button.undo-action-button.row-icon-button:disabled,
:host ::ng-deep #home-content button.undo-action-button.row-icon-button[disabled],
:host ::ng-deep #home-content .undo-action-button.row-icon-button.p-disabled,
:host ::ng-deep #home-content .undo-action-button.row-icon-button.ui-state-disabled,
:host ::ng-deep #home-content .row-icon-button:disabled i,
:host ::ng-deep #home-content .row-icon-button[disabled] i,
:host ::ng-deep #home-content .row-icon-button.p-disabled i,
:host ::ng-deep #home-content .row-icon-button.ui-state-disabled i {
  color: #6f6f6f !important;
}
@media (max-width: 900px) {
  .filters-grid {
    width: 100%;
    margin: 8px 0 0;
  }
  .filter-actions-row {
    width: 100%;
    margin: 16px 0 0;
  }
}
/*# sourceMappingURL=contract-manual.component-2X2SFRPO.css.map */
